import Vue from 'vue'
import VueRouter from 'vue-router'
import UserLogin from '../views/nologin/UserLogin.vue'
import HomeView from '../views/HomeView.vue'
import RegisterView from '../views/nologin/RegisterView.vue'
import NumManage from '../views/NumManage.vue'
import LotteryMange from '../views/LotteryMange.vue'
import BetNumView from '../views/num/BetNumView.vue'
import PrizeManageView from '../views/PrizeManage.vue'
import NumPrizeView from '../views/num/NumPrizeView.vue'
import FeedbackView from '../views/help/FeedbackView.vue'
import GameRulesView from '../views/help/GameRulesView.vue'
import BuyGuideView from '../views/help/BuyGuideView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/register',
    name: 'RegisterView',
    component: RegisterView
  },
  {
    path: '/home',
    name: 'HomeView',
    component: HomeView
  },
  {
    path: '/num-manage',
    name: 'NumManage',
    component: NumManage
  },
  {
    path: '/lottery-mange',
    name: 'LotteryMange',
    component: LotteryMange
  },
  {
    path: '/bet-num',
    name: 'BetNumView',
    component: BetNumView
  },
  {
    path: '/prize-manage',
    name: 'PrizeManageView',
    component: PrizeManageView
  },
  {
    path: '/num-prize',
    name: 'NumPrizeView',
    component: NumPrizeView
  },
  {
    path: '/feedback',
    name: 'FeedbackView',
    component: FeedbackView
  },
  {
    path: '/game-rules',
    name: 'GameRulesView',
    component: GameRulesView
  },
  {
    path: '/buy-guide',
    name: 'BuyGuideView',
    component: BuyGuideView
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
